import React, { ReactNode } from "react";
import {
  Box,
  Button,
  Drawer,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  Flex,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
import { FiFilter } from "@react-icons/all-files/fi/FiFilter";

type TutorialsFiltersDrawerProps = {
  children: ReactNode;
  hasFilters: boolean;
  clearFilter: () => void;
};

export function TutorialsFiltersDrawer({
  children,
  hasFilters,
  clearFilter,
}: TutorialsFiltersDrawerProps) {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const bg = useColorModeValue("white", "gray.700");
  return (
    <>
      <Button
        isFullWidth
        mb="6"
        size="lg"
        colorScheme="indigo"
        leftIcon={<FiFilter />}
        onClick={onOpen}
      >
        Filter results
      </Button>
      <Drawer placement="left" isOpen={isOpen} onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <Flex h="full" direction="column" overflow="auto">
            <Box p="6">{children}</Box>
            <Flex
              mt="auto"
              py="4"
              pr="4"
              pl="2"
              borderTopWidth={1}
              bg={bg}
              pos="sticky"
              bottom="0"
            >
              {hasFilters && (
                <Button variant="ghost" onClick={clearFilter}>
                  Clear filters
                </Button>
              )}
              <Button ml="auto" onClick={onClose} colorScheme="indigo">
                Apply
              </Button>
            </Flex>
          </Flex>
        </DrawerContent>
      </Drawer>
    </>
  );
}
